import React from "react";
import styled from "@emotion/styled";
import CalendarMonth from "./CalendarMonth";
import June from "./June";
import May from "./May";

function Calendar() {
  return (
    <Container>
      <May />
      <June />
      {/* <June />
      <CalendarMonth
        monthName="July"
        numDaysInMonth={31}
        startOfMonthOffset={1}
      /> */}
    </Container>
  );
}

export default Calendar;

const Container = styled.div`
  padding-bottom: 2em;
  padding-top: 3em;
`
